import { ConfService } from 'src/conf.service';

const rootApiUrl = ConfService.conf.environment.apiRootUrl;

export const ApiConfig = {

    AlertsApiConfig: {
        searchAlerts: `/api/Alerts/searchAlerts`,
        getAlertsByUserId: `/api/Alerts/getAlertsByUserId`,
        getActiveAlertGroupInfo: `/api/Alerts/getActiveAlertGroupInfo`,
        getAlertStatus: `/api/Alerts/getAlertStatus`,
        getAlertTypes: `/api/Alerts/getAlertTypes`,
        getLocationId: `/api/Alerts/getLocationId`,
        writeAlert: `/api/Alerts/writeAlert`,
        createAlert: `/api/Alerts/createAlert`,
        setAlertAcknowledge: `/api/Alerts/setAlertAcknowledge`,
        getUserLocations2: `/api/Alerts/getUserLocations2`,
        saveRGANumber: `/api/Alerts/saveRGANumber`,
        setAlertStatus: `/api/Alerts/setAlertStatus`,
        uspAlertsByUserId: `/api/Alerts/uspAlertsByUserId`,
    },

    AuthApiConfig: {
        bartPrivs: `/api/Auth/bartPrivs`
    },

    BatchApiConfig: {
        addBatch: `/api/Batch/addBatch`,
        addBatchPart: `/api/Batch/addBatchPart`,
        addDiscreteMeasure: `/api/Batch/addDiscreteMeasure`,
        deleteBatch: `/api/Batch/deleteBatch`,
        deleteBatchPart: `/api/Batch/deleteBatchPart`,
        deleteDiscreteMeasure: `/api/Batch/deleteDiscreteMeasure`,
        getBatches: `/api/Batch/getBatches`,
        getBatchMeasures: `/api/Batch/getBatchMeasures`,
        getBatchParts: `/api/Batch/getBatchParts`,
        getDiscreteMeasures: `/api/Batch/getDiscreteMeasures`,
        createChecklistResponseParent: `/api/Batch/createChecklistResponseParent`,
        createChecklistResponseSub: `/api/Batch/createChecklistResponseSub`,
        updateBatch: `/api/Batch/updateBatch`,
        updateBatchPart: `/api/Batch/updateBatchPart`,
        updateDiscreteMeasure: `/api/Batch/updateDiscreteMeasure`,
        getBatchesDD: `/api/Batch/getBatchesDD`,

    },

    ChecklistApiConfig: {
        getWLDashboard: `/api/Checklist/getWLDashboard`,
        getChecklist: `/api/Checklist/getChecklist`,
        createChecklistResponse: `/api/Checklist/createChecklistResponse`,
        createChecklistResponseParent: `/api/Checklist/createChecklistResponseParent`,
        createChecklistResponseSub: `/api/Checklist/createChecklistResponseSub`,

    },

    ContentApiConfig: {
        addContent: `/api/Content/addContent`,
        addContentGroup: `/api/Content/addContentGroup`,
        editContent: `/api/Content/editContent`,
        editContentGroup: `/api/Content/editContentGroup`,
        getContentByGroupID: `/api/Content/getContentByGroupID`,
        getContentByID: `/api/Content/getContentByID`,
        getContentFiles: `/api/Content/getContentFiles`,
        getContentFilesByContentID: `/api/Content/getContentFilesByContentID`,
        getContentGroups: `/api/Content/getContentGroups`,
        getContentGroupsByContentID: `/api/Content/getContentGroupsByContentID`,
        getFileType: `/api/Content/getFileType`,
        removeContent: `/api/Content/removeContent`,
        removeContentGroup: `/api/Content/removeContentGroup`,
        uploadFile: `/api/Content/uploadFile`,
    },

    EquipmentApiConfig: {
        addEquipmentSchedule: `/api/Equipment/addEquipmentSchedule`,
        checkModelSchedule: `/api/Equipment/checkModelSchedule`,
        getEquipmentConditions: `/api/Equipment/getEquipmentConditions`,
        getEquipmentDetails: `/api/Equipment/getEquipmentDetails`,
        getEquipmentHistoryResults: `/api/Equipment/getEquipmentHistoryResults`,
        getEquipmentLocationId: `/api/Equipment/getEquipmentLocationId`,
        updateEquipment: `/api/Equipment/updateEquipment`,
        updateEquipmentStatus: `/api/Equipment/updateEquipmentStatus`,
        getEquipmentModality: `/api/Equipment/getEquipmentModality`,
        getEquipmentOrigins: `/api/Equipment/getEquipmentOrigins`,
        getEquipmentScheduleHistory: `/api/Equipment/getEquipmentScheduleHistory`,
        getEquipmentStatus: `/api/Equipment/getEquipmentStatus`,
        getEquipmentStatusId: `/api/Equipment/getEquipmentStatusId`,
        getEquipmentSubTypes: `/api/Equipment/getEquipmentSubTypes`,
        getEquipmentTickets: `/api/Equipment/getEquipmentTickets`,
        getEquipmentTypes: `/api/Equipment/getEquipmentTypes`,
        getEquipmManEquipDetails: `/api/Equipment/getEquipmManEquipDetails`,
        getFacilityEquipment: `/api/Equipment/getFacilityEquipment`,
        getFacilityEquipmentList: `/api/Equipment/getFacilityEquipmentList`,
        getFacilityEquipmentManager: `/api/Equipment/getFacilityEquipmentManager`,
        getFacilityEquipmentMassTransfer: `/api/Equipment/getFacilityEquipmentMassTransfer`,
        getFacilityIdByEquipmentId: `/api/Equipment/getFacilityIdByEquipmentId`,
        addEquipment: `/api/Equipment/addEquipment`,
        getModelWarrantyInfo: `/api/Equipment/getModelWarrantyInfo`,
        getPMSequence: `/api/Equipment/getPMSequence`,
        getRepairResults: `/api/Equipment/getRepairResults`,
        setLastClockHours: `/api/Equipment/setLastClockHours`,
        transferEquipment: `/api/Equipment/transferEquipment`,
        updateEquipmentLocation: `/api/Equipment/updateEquipmentLocation`,
        updateEquipmentScheduleByModel: `/api/Equipment/updateEquipmentScheduleByModel`,
        getEquipmentMpi: `/api/Equipment/getEquipmentMpi`,
        insertUpdateEquipmentMpi: `/api/Equipment/insertUpdateEquipmentMpi`,
        mergeEquipment: `/api/Equipment/mergeEquipment`,
        getEquipmentAlerts: `/api/Equipment/getEquipmentAlerts`,
        validateIproc: `/api/Equipment/validateIproc`,
        validateSerial: `/api/Equipment/validateSerial`,
        //Start:Added By Harikesh on 08-June-2020
        getMachineNickName: `/api/Equipment/getMachineNickName`,
        getMachineIPAddress: `/api/Equipment/getMachineIPAddress`,
        //End:Added By Harikesh on 08-June-2020
        UpdateNickName: `/api/Equipment/UpdateNickName`,
        validateMachineNickName: `/api/Equipment/validateMachineNickName`,
        validateMachineIPAddress: `/api/Equipment/validateMachineIPAddress`,
        getPMTypes: `/api/Equipment/getPMTypes`,

    },

    EquipmentModalityApiConfig: {
        getEquipmentModality: `/api/EquipmentModality/getEquipmentModality`,

    },

    FacilityApiConfig: {
        getFilteredFacilityDetails: `/api/Facility/getFilteredFacilityDetails`,
        getFacilityInfo: `/api/Facility/getFacilityInfo`,
        getLocationTypeId: `/api/Facility/getLocationTypeId`,
        getUserLocations: `/api/Facility/getUserLocations`,
        getUserFacilities: `/api/Facility/getUserFacilities`,
    },

    FavouritesApiConfig: {
        addFavoriteList: `/api/Favorite/addFavoriteList`,
        addFavoriteListType: `/api/Favorite/addFavoriteListType`,
        deleteFavoriteList: `/api/Favorite/deleteFavoriteList`,
        deleteFavoriteListPart: `/api/Favorite/deleteFavoriteListPart`,
        deleteFavoriteListTestEquip: `/api/Favorite/deleteFavoriteListTestEquip`,

        deleteTestFavoriteList: `/api/Favorite/deleteTestFavoriteList`,

        deleteFavoriteListType: `/api/Favorite/deleteFavoriteListType`,
        getFavoriteList: `/api/Favorite/getFavoriteList`,

        getFavoriteListParts: `/api/Favorite/getFavoriteListParts`,
        getFavoriteListTestEquip: `/api/Favorite/getFavoriteListTestEquip`,
        getFavoriteTypes: `/api/Favorite/getFavoriteTypes`,
        updateFavoriteListType: `/api/Favorite/updateFavoriteListType`,
        addFavoriteListPart: `/api/Favorite/addFavoriteListPart`,
        addFavoriteListTestEquip: `/api/Favorite/addFavoriteListTestEquip`,
        updateFavoriteList: `/api/Favorite/updateFavoriteList`,
        updateFavoriteListPart: `/api/Favorite/updateFavoriteListPart`,
        updateFavoriteListTestEquip: `/api/Favorite/updateFavoriteListTestEquip`,


    },

    ManufacturerApiConfig: {
        addManufacturer: `/api/Manufacturer/addManufacturer`,
        checkManufacturer: `/api/Manufacturer/checkManufacturer`,
        checkManufacturerInternal: `/api/Manufacturer/checkManufacturerInternal`,
        getManufacturers: `/api/Manufacturer/getManufacturers`,
        getManufacturersForAddEquip: `/api/Manufacturer/getManufacturersForAddEquip`,
        getVendors: `/api/Manufacturer/getVendors`,
        getVendorInfo: `/api/Manufacturer/getVendorInfo`,
        updateManufacturer: `/api/Manufacturer/updateManufacturer`,
        updateManufacturerActiveFlag: `/api/Manufacturer/updateManufacturerActiveFlag`,

    },

    ModelApiConfig: {
        addModel: `/api/Model/addModel`,
        addModelEquipmentSubTypes: `/api/Model/addModelEquipmentSubTypes`,
        checkModel: `/api/Model/checkModel`,
        checkModelInternal: `/api/Model/checkModelInternal`,
        deleteModelEquipmentSubTypes: `/api/Model/deleteModelEquipmentSubTypes`,
        getManufacturerModels: `/api/Model/getManufacturerModels`,
        getModels: `/api/Model/getModels`,
        getModelsAndManufacturers: `/api/Model/getModelsAndManufacturers`,
        getModelEquipmentSubTypes: `/api/Model/getModelEquipmentSubTypes`,
        getModelInfo: `/api/Model/getModelInfo`,
        getModelSchedule: `/api/Model/getModelSchedule`,
        addModelSchedule: `/api/Model/addModelSchedule`,
        getModelsForAddEquip: `/api/Model/getModelsForAddEquip`,
        getPMSchedule: `/api/Model/getPMSchedule`,
        getPMScheduleForOEM: `/api/Model/getPMScheduleForOEM`,
        getScheduleFrequency: `/api/Model/getScheduleFrequency`,
        searchModels: `/api/Model/searchModels`,
        updateModelSchedule: `/api/Model/updateModelSchedule`,
        updateModel: `/api/Model/updateModel`,
        updateModelActiveFlag: `/api/Model/updateModelActiveFlag`,
        updatePMSchedule: `/api/Model/updatePMSchedule`,
    },

    PacApiConfig: {
        getSRDashboard: `/api/Pac/getSRDashboard`,
        getCommon_Questions: `/api/Pac/getCommon_Questions`,
        getCommonQuestionValues: `/api/Pac/getCommonQuestionValues`,
        getPACAll: `/api/Pac/getPACAll`,
        getPAC: `/api/Pac/getPAC`,
        getPACDashboard: `/api/Pac/getPACDashboard`,
        getDelayReasons: `/api/Pac/getDelayReasons`,
        createPACResponse: `/api/Pac/createPACResponse`,
        createPACGroup: `/api/Pac/createPACGroup`,
    },

    PartsApiConfig: {
        deleteModelParts: `/api/Parts/deleteModelParts`,
        removeModelFromVendor: `/api/Parts/removeModelFromVendor`,
        getModelParts: `/api/Parts/getModelParts`,
        GetPartByPartId: `/api/Parts/GetPartByPartId`,
        getPartModels: `/api/Parts/getPartModels`,
        getPartManufacturers: `/api/Parts/getPartManufacturers`,
        getParts: `/api/Parts/getParts`,
        getPartGroups: `/api/Parts/getPartGroups`,
        isPartUnderWarranty: `/api/Parts/isPartUnderWarranty`,
        isPartUnique: `/api/Parts/isPartUnique`,
        createAdHocPart: `/api/Parts/createAdHocPart`,
        assignModelsToParts: `/api/Parts/assignModelsToParts`,
        updatePartModels: `/api/Parts/updatePartModels`,
        assignModelsToVendor: `/api/Parts/assignModelsToVendor`,
        searchParts: `/api/Parts/searchParts`,
        updatePartDetail: `/api/Parts/updatePartDetail`,
        mergePart: `/api/Parts/mergePart`,

    },

    PayrollCodeApiConfig: {
        getPayrollCodes: `/api/PayrollCode/getPayrollCodes`,
    },

    QuestionsApiConfig: {
        getQuestions: `/api/Questions/getQuestions`,
        getQuestionsByEquipmentId: `/api/Questions/getQuestionsByEquipmentId`,

    },

    ReportsApiConfig: {
        columnDefinitions: `/api/Reports/columnDefinitions`,
        getReports: `/api/Reports/getReports`,
        runReport: `/api/Reports/runReport`,
    },

    ResourceApiConfig: {
        getResourcesSP: `/api/Resource/getResourcesSP`,
        getResourceFiles: `/api/Resource/getResourceFiles`,
        getResources: `/api/Resource/getResources`,
        createResourceFile: `/api/Resource/createResourceFile`,
        createResource: `/api/Resource/createResource`,
        updateResource: `/api/Resource/updateResource`,
        uploadFile: `/api/Resource/uploadFile`,
        availableFiles: `/api/Resource/availableFiles`,

    },

    ServicerequestApiConfig: {
        getServiceRequest: `/api/Servicerequest/getServiceRequest`,
        getServiceRequestIds: `/api/Servicerequest/getServiceRequestIds`,
        getServiceRequestTypes: `/api/Servicerequest/getServiceRequestTypes`,
        createServiceRequest: `/api/Servicerequest/createServiceRequest`,
        removeTicketFromServiceRequest: `/api/Servicerequest/removeTicketFromServiceRequest`,
        voidServiceRequest: `/api/Servicerequest/voidServiceRequest`,
        setServiceRequestTicket: `/api/Servicerequest/setServiceRequestTicket`,

    },

    SettingsApiConfig: {
        getUserSetting: `/api/Settings/getUserSetting`,
        setUserSetting: `/api/Settings/setUserSetting`,
    },

    SqacodeApiConfig: {
        deleteSQACode: `/api/Sqacode/deleteSQACode`,
        deleteEquipmentTypeLink: `/api/Sqacode/deleteEquipmentTypeLink`,
        deleteSQACodeLink: `/api/Sqacode/deleteSQACodeLink`,
        updateSQACodeLink: `/api/Sqacode/updateSQACodeLink`,
        getBatchSQA: `/api/Sqacode/getBatchSQA`,
        getEquipmentSQACodes: `/api/Sqacode/getEquipmentSQACodes`,
        getWorkTypeSQACodes: `/api/Sqacode/getWorkTypeSQACodes`,
        getSQACodeEquipmentTypes: `/api/Sqacode/getSQACodeEquipmentTypes`,
        getServiceReqSqaCodes: `/api/Sqacode/getServiceReqSqaCodes`,
        getEquipmentTypeSQACodes: `/api/Sqacode/getEquipmentTypeSQACodes`,
        getSQACodeDisplayOrder: `/api/Sqacode/getSQACodeDisplayOrder`,
        getWebFormSQACodes: `/api/Sqacode/getWebFormSQACodes`,
        getSQACodes: `/api/Sqacode/getSQACodes`,
        createEquipmentTypeLink: `/api/Sqacode/createEquipmentTypeLink`,
        createSQACode: `/api/Sqacode/createSQACode`,
        createSQACodeLink: `/api/Sqacode/createSQACodeLink`,
        updateSQACode: `/api/Sqacode/updateSQACode`,

    },

    SqasubcodeApiConfig: {
        createSQASubCode: `/api/Sqasubcode/createSQASubCode`,
        deleteSQASubCodeLink: `/api/Sqasubcode/deleteSQASubCodeLink`,
        deleteSQACode: `/api/Sqasubcode/deleteSQACode`,
        getSqaSubCodes: `/api/Sqasubcode/getSqaSubCodes`,
        getSQASubCodeDisplayOrder: `/api/Sqasubcode/getSQASubCodeDisplayOrder`,
        createSQASubCodeLink: `/api/Sqasubcode/createSQASubCodeLink`,
        updateSQASubCode: `/api/Sqasubcode/updateSQASubCode`,

    },

    TestequipApiConfig: {
        getTestEquip: `/api/Testequip/getTestEquip`,

    },

    TicketApiConfig: {
        clearTicketTestEquip: `/api/Tickets/clearTicketTestEquip`,
        clearTicketParts: `/api/Tickets/clearTicketParts`,
        dashTickets: `/api/Tickets/dashTickets`,
        getTicket: `/api/Tickets/getTicket`,
        getTicketParts: `/api/Tickets/getTicketParts`,
        getTicketPartSource: `/api/Tickets/getTicketPartSource`,
        loadTicketQuestion: `/api/Tickets/loadTicketQuestion`,
        addTicketNote: `/api/Tickets/addTicketNote`,
        addTicketPart: `/api/Tickets/addTicketPart`,
        saveTicketQuestion: `/api/Tickets/saveTicketQuestion`,
        getTicketRecords: `/api/Tickets/getTicketRecords`,
        updateTicket: `/api/Tickets/updateTicket`,
        CloseBatchTicket: `/api/Tickets/CloseBatchTicket`,
        closeTicket: `/api/Tickets/closeTicket`,
        addTicketTestEquip: `/api/Tickets/addTicketTestEquip`,
        addBatchTicketParts: `/api/Tickets/addBatchTicketParts`,
        checkBatchEquipment: `/api/Tickets/checkBatchEquipment`,
        CreateBatchTicket: `/api/Tickets/CreateBatchTicket`,
        createTicket: `/api/Tickets/createTicket`,
        createTicketFromServiceRequest: `/api/Tickets/createTicketFromServiceRequest`,
        getTicketTestEquip: `/api/Tickets/getTicketTestEquip`,
        voidClosedTicket: `/api/Tickets/voidClosedTicket`,


    },

    UserApiConfig: {
        getUsers: `/api/User/getUsers`,
        logUserAction: `/api/User/logUserAction`,
        getUserHostInfo: `/api/User/getUserHostInfo`,
    },

    WorktypeApiConfig: {
        getWorkTypes: `/api/Worktype/getWorkTypes`,

    },
    //#region Water Lab
    LabRequestApiConfig: {
        getLabRequests: `/api/LabRequest/getLabRequests`,
        getLaborataryMasterData: `/api/LabRequest/getLaboratory`,
        getProviderMasterData: `/api/LabRequest/getProviders`,
        getLabTestMasterData: `/api/LabRequest/getLabTests`,
        getLabProfileMasterData: `/api/LabRequest/getLabProfiles`,
        getLabDropDownBox: `/api/LabRequest/getDropdownBox`,
        upsertLabRequest: `/api/LabRequest/upsertLabRequest`,
        getLabRequestDetails: `/api/LabRequest/getLabRequestDetails`,
        getFacilityEquipmentsForLab: `/api/LabRequest/getFacilityEquipmentsForLab`,
        getLabRequestHistory: `/api/LabRequest/getLabRequestHistory`,
        disContinueLabRequest: `/api/LabRequest/disContinueLabRequest`,
        getLabFrequency: `/api/LabRequest/getLabFrequency`
    },

    LabRequisitionApiConfig: {
        getLabelSummary: `/api/LabRequisition/getLabelSummary`,
        printLabelSummary: `/api/LabRequisition/printLabelSummary`,
        getFacilityDetails: `/api/Facility/getFacilityInfo`,
        createLabRequisition: `/api/LabRequisition/createLabRequisition`,
        redrawLabResult: `/api/LabRequisition/redrawLabResult`,
        getLabRequisitionData: `/api/LabRequisition/getLabRequisitions`,
        getShipmentReceivedDate: `/api/LabRequisition/getShipmentReceivedDate`,
        updateDrawDate: `/api/LabRequisition/updateLabRequisitionDrawDate`,
        updatePrintLabelDate: `/api/LabRequisition/updateLabRequisitionPrintLabelDate`,
        cancelRequisition: `/api/LabRequisition/cancelLabRequisition`,
        updateLabRequisitionStatus: `/api/LabRequisition/updateLabRequisitionStatus`,
        CreateRequisitionForAdditionalTest: `/api/LabRequisition/CreateRequisitionForAdditionalTest`,
        updateShippingManifest: `/api/LabRequisition/updateShippingManifest`,
        printShippingManifest: `/api/LabRequisition/printShippingManifest`,
        getLabResult: `/api/LabRequisition/getLabResult`,
        getLabRequisitionHistory: `/api/LabRequisition/getLabRequisitionHistory`,
        printZPL: `/api/LabRequisition/zebraPrintRedirect`,
        isZebraPrinterAvailable: `/api/LabRequisition/isZebraPrinterAvailable`,
        getPrintLabelDate: `/api/LabRequisition/getPrintLabelDate`
    },
    LabManagerApiConfig: {
        getLabModels: `/api/LabManager/getLabModels`,
        getLabTestByModel: `/api/LabManager/getLabTestByModel`,
        getAllLabTestsAndProfiles: `/api/LabManager/getAllLabTestAndProfile`,
        getLabFrequencyAlertsRule: `/api/LabManager/getLabFrequencyAlertsRule`,
        updateLabFrequencyAlertRule: `/api/LabManager/updateLabFrequencyAlertRule`,
        getStateException: `/api/LabManager/getStateException`,
        UpdateStateException: `/api/LabManager/UpdateStateException`,
        getLabRangeAlertRules: `/api/LabManager/getLabRangeAlertRules`,
        getLabRangeAlertRuleByTest: `/api/LabManager/getLabRangeAlertRuleByTest`,
        updateLabRangeAlertRule: `/api/LabManager/updateLabRangeAlertRule`,


        updateLabTestByModel: `/api/LabManager/updateLabTestByModel`,
        updateLabTestAndProfileStatus: `/api/LabManager/updateLabTestAndProfileStatus`,
    },
    LabActionItemApiConfig: {
        getNoLabRequestActionItems: `/api/LabActionItem/getNoLabRequestActionItems`,
        getLabActionItemTabDetails: `/api/LabActionItem/getLabActionItemTabDetails`,
        getOverdueActionItems: `/api/LabActionItem/getOverdueActionItems`,
        getRedrawActionItems: `/api/LabActionItem/getRedrawActionItems`,
        getUpcomingLabActionItems: `/api/LabActionItem/getUpcomingLabActionItems`,
        getUnmappedLabTestActionItems: `/api/LabActionItem/getUnmappedLabTestActionItems`,
        getLabAlertActionItems: `/api/LabActionItem/getLabAlertActionItems`,
        getMissingDrawDateActionItems: `/api/LabActionItem/getMissingDrawDateActionItems`,
    }
    //#endregion
};
